"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
var events_1 = require("events");
var ExtAdapter_1 = require("../modules/ExtAdapter");
var ExtFrameMessage_1 = __importDefault(require("../ext/ExtFrameMessage"));
var capability_1 = require("../util/capability");
var service_1 = __importDefault(require("../util/service"));
var ExtEndpointModule_1 = require("../ext/ExtEndpointModule");
var ExtLogger_1 = __importDefault(require("./ExtLogger"));
var util_1 = require("../util");
var ext_1 = require("../util/ext");
var tracking_1 = require("../util/tracking");
/**
 *  小程序中台组件
 */
var ExtComp = /** @class */ (function (_super) {
    __extends(ExtComp, _super);
    function ExtComp() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * 初始化
     * @param adapter 小程序适配器
     */
    ExtComp.prototype.init = function (adapter) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        tracking_1.globalMark('enter');
                        this.adapter = adapter;
                        this.logger = ExtLogger_1["default"].getGlobalLogger(function (logContent) {
                            return adapter.log(logContent);
                        });
                        return [4 /*yield*/, capability_1.ensureBrowserSupport()];
                    case 1:
                        _a.sent();
                        return [4 /*yield*/, this.handleFrameMessage(adapter)];
                    case 2:
                        _a.sent();
                        return [4 /*yield*/, this.handleDevMessage(adapter)];
                    case 3:
                        _a.sent();
                        return [4 /*yield*/, this.adapter.ensureSupport()];
                    case 4:
                        _a.sent();
                        return [4 /*yield*/, this.adapter.playerReady()];
                    case 5:
                        _a.sent();
                        return [4 /*yield*/, this.adapter.registryExtEndpointModule()];
                    case 6:
                        _a.sent();
                        return [4 /*yield*/, this.adapter.handleMessage()];
                    case 7:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    /**
     * 拉取小程序列表
     */
    ExtComp.prototype.fetchExtMainList = function (isInner) {
        return __awaiter(this, void 0, void 0, function () {
            var _a, _b;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        if (!!isInner) return [3 /*break*/, 2];
                        _a = this;
                        return [4 /*yield*/, service_1["default"].getProfileExtList(this.adapter)];
                    case 1:
                        _a.extMainList = _c.sent();
                        return [3 /*break*/, 4];
                    case 2:
                        _b = this;
                        return [4 /*yield*/, service_1["default"].getPositionExtList(this.adapter)];
                    case 3:
                        _b.extMainList = _c.sent();
                        _c.label = 4;
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    /**
     *
     * @param adapter
     */
    /**
     * 处理小程序iframe消息
     * @param adapter 小程序适配器
     */
    ExtComp.prototype.handleFrameMessage = function (adapter) {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                window.addEventListener('message', function (evt) { return __awaiter(_this, void 0, void 0, function () {
                    var source, origin, data, extEndpointModule, msg, handleFrameMessageResp, handleType, rsp, err, err_1;
                    return __generator(this, function (_a) {
                        switch (_a.label) {
                            case 0:
                                source = evt.source, origin = evt.origin, data = evt.data;
                                return [4 /*yield*/, this.adapter.isOriginValid(origin)];
                            case 1:
                                if (!_a.sent()) return [3 /*break*/, 5];
                                extEndpointModule = this.adapter.extEndpointModulesManager.getExtEndpointModuleBySource(source);
                                if (!extEndpointModule) return [3 /*break*/, 5];
                                msg = new ExtFrameMessage_1["default"](data);
                                _a.label = 2;
                            case 2:
                                _a.trys.push([2, 4, , 5]);
                                return [4 /*yield*/, extEndpointModule.handleFrameMessage(msg, adapter)];
                            case 3:
                                handleFrameMessageResp = _a.sent();
                                handleType = handleFrameMessageResp.handleType, rsp = handleFrameMessageResp.rsp, err = handleFrameMessageResp.err;
                                if (handleType === ExtAdapter_1.HandleType.RESPONSABLE) {
                                    if (err) {
                                        if (msg.errTopic) {
                                            extEndpointModule.extFrame.postErr(msg.errTopic, msg.reqId, err.message, adapter);
                                        }
                                    }
                                    else {
                                        if (msg.rspTopic) {
                                            extEndpointModule.extFrame.postRsp(msg.rspTopic, msg.reqId, rsp, adapter);
                                        }
                                    }
                                }
                                return [3 /*break*/, 5];
                            case 4:
                                err_1 = _a.sent();
                                if (msg.errTopic) {
                                    extEndpointModule.extFrame.postErr(msg.errTopic, msg.reqId, err_1.message, adapter);
                                }
                                if (process.env.NODE_ENV === 'development') {
                                    throw err_1;
                                }
                                else {
                                    this.logger.warn('处理小程序iframe消息失败', { err: err_1.message });
                                }
                                return [3 /*break*/, 5];
                            case 5: return [2 /*return*/];
                        }
                    });
                }); });
                return [2 /*return*/];
            });
        });
    };
    /**
     * 处理小程序平台消息
     * @param adapter 小程序适配器
     */
    ExtComp.prototype.handleDevMessage = function (adapter) {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, adapter.addDevExtMessagePushHandler(function (data) {
                            _this.logger.debug('收到小程序业务广播消息', data);
                            try {
                                var _a = data.header, extUuid = _a.extUuid, messType = _a.messType;
                                var _b = data.body, event_1 = _b.event, content_1 = _b.content;
                                var extEndpointModuleList = _this.adapter.extEndpointModulesManager.getExtEndpointModuleListWithExtUuid(extUuid);
                                switch (messType) {
                                    case String(ext_1.DevMessageType.DEV_SYS):
                                        switch (event_1) {
                                            case String(ExtAdapter_1.MessageEvent.TEXT_NOTICE):
                                            case String(ExtAdapter_1.MessageEvent.STATUS_NOTICE):
                                                var c_1 = JSON.parse(util_1.unescapeHTML(content_1));
                                                extEndpointModuleList.forEach(function (extEndpointModule) {
                                                    if (c_1.componentTypeTags.indexOf(extEndpointModule.extEndpoint.extType) >= 0) {
                                                        switch (event_1) {
                                                            case String(ExtAdapter_1.MessageEvent.TEXT_NOTICE):
                                                                extEndpointModule.textNotice(c_1, adapter);
                                                                break;
                                                            case String(ExtAdapter_1.MessageEvent.STATUS_NOTICE):
                                                                extEndpointModule.statusNotice(__assign(__assign({}, extEndpointModule.extEndpoint.typeAuthority
                                                                    .extTypeIconInfo), c_1), adapter);
                                                                break;
                                                        }
                                                    }
                                                });
                                                break;
                                            default:
                                                extEndpointModuleList.forEach(function (extEndpointModule) {
                                                    extEndpointModule.postContextMessage(event_1, util_1.unescapeHTML(content_1), adapter);
                                                });
                                                break;
                                        }
                                        break;
                                    case ext_1.DevMessageType.DEV_EXT:
                                        extEndpointModuleList.forEach(function (extEndpointModule) {
                                            extEndpointModule.postObserverMessage(event_1, util_1.unescapeHTML(content_1), adapter);
                                        });
                                        break;
                                    default:
                                        _this.logger.warn('未能处理的messType', { messType: messType });
                                        break;
                                }
                            }
                            catch (err) {
                                _this.logger.warn('Taf的推送消息处理失败', { err: err.message });
                            }
                        })];
                    case 1:
                        _a.sent();
                        return [4 /*yield*/, adapter.addDevExtMessageSystemHandler(function (data) {
                                _this.logger.info('收到小程序系统广播消息', data);
                                try {
                                    var _a = data.header, extUuid = _a.extUuid, messType = _a.messType;
                                    var _b = data.body, event_2 = _b.event, content_2 = _b.content;
                                    var extEndpointList = _this.adapter.extEndpointModulesManager.getExtEndpointModuleListWithExtUuid(extUuid);
                                    if (messType === ext_1.DevMessageType.DEV_SYS) {
                                        switch (event_2) {
                                            case String(ExtAdapter_1.MessageEvent.EXT_CLOSE):
                                                var extVersionTypes_1 = [3];
                                                try {
                                                    extVersionTypes_1 = JSON.parse(util_1.unescapeHTML(content_2))
                                                        .extVersionTypes.split(',')
                                                        .map(Number);
                                                }
                                                catch (err) {
                                                    _this.logger.warn('解析错误', err.message);
                                                }
                                                extEndpointList.forEach(function (extEndpointModule) {
                                                    if (extVersionTypes_1.indexOf(Number(extEndpointModule.extMain.extVersionType)) >= 0) {
                                                        extEndpointModule.close(util_1.unescapeHTML(content_2), adapter);
                                                    }
                                                });
                                                break;
                                        }
                                    }
                                }
                                catch (err) {
                                    _this.logger.warn('处理小程序系统广播消息错误', { err: err.message });
                                }
                            })];
                    case 2:
                        _a.sent();
                        return [4 /*yield*/, adapter.addDevLiveEventMessagePushHandler(function (data) {
                                _this.logger.info('收到小程序通用广播消息', data);
                                try {
                                    var extUuid = data.header.extUuid;
                                    var event_3 = data.body.event;
                                    var extEndpointList = _this.adapter.extEndpointModulesManager.getExtEndpointModuleListWithExtUuid(extUuid);
                                    extEndpointList.forEach(function (extEndpointModule) {
                                        extEndpointModule.bus.getBus(ExtEndpointModule_1.BusType.LIVE_EVENT).emit(event_3, __assign(__assign({}, data), { body: __assign(__assign({}, data.body), { content: util_1.unescapeHTML(data.body.content) }) }));
                                    });
                                }
                                catch (err) {
                                    _this.logger.warn('处理小程序通用广播消息错误', { err: err.message });
                                }
                            })];
                    case 3:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    /**
     * 渲染一个小程序面板endpoint模块（TODO），先用ExtEndpointModulesManager.renderAll来替代
     * @param extMain 小程序主体信息
     * @param extComEndpoint 小程序endpoint信息
     */
    ExtComp.prototype.renderExtEnpointModulePanel = function (extMain, extComEndpoint) {
        throw new Error('not implemented');
    };
    /**
     * 渲染一个小程序浮窗endpoint模块容器（TODO），先用ExtEndpointModulesManager.renderAll来替代
     * @param extMain 小程序主体信息
     * @param extComEndpoint 小程序endpoint信息
     */
    ExtComp.prototype.renderExtEnpointModulePopupContainer = function (extMain, extComEndpoint) {
        throw new Error('not implemented');
    };
    return ExtComp;
}(events_1.EventEmitter));
exports["default"] = ExtComp;
